/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { Component, Input, OnInit } from '@angular/core';
import { faFileSignature, faSignature } from '@fortawesome/pro-regular-svg-icons';
import { SignatureRecordData } from '../../../../../../../../models/record/items/signature-record.model';

@Component({
  selector: 'signature-record',
  templateUrl: './signature-record.component.html',
  styleUrls: ['./signature-record.component.scss'],
  standalone: false
})
export class SignatureRecordComponent implements OnInit {
  @Input() record!: SignatureRecordData;

  faFileSignature = faFileSignature;
  faSignature = faSignature;

  constructor() {}

  ngOnInit() {}
}
